/**
 * Google Tag Manager Initialization
 * Initializes GTM with the configured ID from environment variables
 */

import config from "./config";

export function registerGTM() {
  if (!config.gtmId) {
    console.warn("GTM_ID not configured");
    return;
  }

  // Initialize GTM dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js"
  });

  // Inject GTM script
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${config.gtmId}`;
  
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(script, firstScript);

  // Inject GTM noscript iframe
  const noscript = document.createElement("noscript");
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${config.gtmId}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";
  noscript.appendChild(iframe);
  
  document.body.insertBefore(noscript, document.body.firstChild);

  console.log("GTM initialized with ID:", config.gtmId);
}

